/** Shared cross-field validation + transition check for COVG-1562's reminder toggle. */

/** Both admin forms represent every numeric field in this group as a string. */
export interface CoverageCreditExpirationReminderFormValue {
  sendExpirationReminderEmail: boolean;
  creditExpirationDays: string;
  expirationReminderDaysBefore: string;
}

function parsePositiveInteger(value: string): number | undefined {
  if (value === "") {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
}

/** Only meaningful once the reminder toggle is on (see field descriptions). */
export function validateCoverageCreditExpirationReminder(
  value: CoverageCreditExpirationReminderFormValue,
): string[] {
  if (!value.sendExpirationReminderEmail) {
    return [];
  }
  const expirationDays = parsePositiveInteger(value.creditExpirationDays);
  if (expirationDays === undefined) {
    return ["Set credit expiration days to use the reminder"];
  }
  const reminderDays = parsePositiveInteger(value.expirationReminderDaysBefore);
  if (reminderDays === undefined) {
    return ["Set days before expiration to a whole number of at least 1"];
  }
  if (reminderDays >= expirationDays) {
    return ["Days before expiration must be less than credit expiration days"];
  }
  return [];
}

/** True only on the off -> on transition, mirroring putTeam's other flags. */
export function coverageCreditExpirationReminderJustEnabled(
  before: boolean | undefined,
  after: boolean | undefined,
): boolean {
  return !before && !!after;
}
